import { USER_ACCOUNT_SETTINGS_FILTERS_API } from 'modules/profile/account-settings/api/account-settings-api'
import { AccountSettingsTimezonesApiInterface } from 'modules/profile/account-settings/types/account-settings-interface'
import useUser from 'shared/hooks/use-user'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

export function useAccountSettingsTimezones() {
  const { user } = useUser()
  const { data } = useSWR<AccountSettingsTimezonesApiInterface>(() => {
    if (user) {
      return USER_ACCOUNT_SETTINGS_FILTERS_API
    }
    return null
  }, baseFetcher)
  return { data }
}
